class EditProfilePermissionChecker {
  hasPermission(currentUser, path) {
    if (!currentUser) {
      return false;
    }

    let { affiliationCd, typeCd: userTypeCd } = currentUser;
    let isAllowed = false;

    if ( userTypeCd === "ISAD" ||
         userTypeCd === "IRAD" || 
         userTypeCd === "PRAD"
     ) {
      isAllowed = true;
    }

    return isAllowed;
  }
}

export default new EditProfilePermissionChecker();
